import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { groupChats } from '@/mocks/groupChats';

export default function GroupChatSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = groupChats[activeIndex];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="群聊高能"
          title="群里一句接一句，笑到隔壁来敲门"
          description="真实的群聊片段最能说明问题：不需要铺垫，一张图、一句接梗，气氛就起来了。"
        />

        <div className="mt-8 grid gap-6 lg:grid-cols-[280px_1fr]">
          <div className="flex gap-3 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
            {groupChats.map((chat, index) => (
              <button
                key={chat.id}
                type="button"
                onClick={() => setActiveIndex(index)}
                aria-pressed={activeIndex === index}
                className={`min-w-[220px] shrink-0 rounded-lg border p-4 text-left transition-colors lg:min-w-0 lg:w-full ${
                  activeIndex === index
                    ? 'border-primary-300 bg-primary-50'
                    : 'border-background-200 bg-background-50 hover:border-background-300'
                }`}
              >
                <span className="flex items-center gap-2">
                  <i
                    className={`ri-group-2-line text-lg ${
                      activeIndex === index ? 'text-primary-600' : 'text-foreground-500'
                    }`}
                    aria-hidden="true"
                  />
                  <span className="text-sm text-foreground-950">{chat.title}</span>
                </span>
                <span className="mt-1.5 block text-xs text-foreground-500">{chat.meta}</span>
              </button>
            ))}
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-6">
            <div className="flex items-center justify-between border-b border-background-200 pb-4">
              <div>
                <h3 className="m-0 text-base text-foreground-950 md:text-lg">{active.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{active.meta}</p>
              </div>
              <span className="flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-xs text-primary-700">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-soft" />
                高能进行中
              </span>
            </div>

            <ul className="mt-4 space-y-3">
              {active.messages.map((message) => (
                <li
                  key={message.id}
                  className={`flex ${message.side === 'right' ? 'justify-end' : 'justify-start'}`}
                >
                  <div
                    className={`max-w-[85%] rounded-lg px-3 py-2 md:max-w-[70%] md:px-4 md:py-2.5 ${
                      message.side === 'right'
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-50 text-foreground-900 border border-background-200'
                    }`}
                  >
                    <p
                      className={`text-xs ${
                        message.side === 'right' ? 'text-primary-100' : 'text-foreground-500'
                      }`}
                    >
                      {message.name}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed">{message.text}</p>
                  </div>
                </li>
              ))}
            </ul>

            <p className="mt-5 rounded-md bg-background-200 px-3 py-2 text-xs text-foreground-600">
              群聊片段由网友提供并做匿名化处理，昵称均为化名。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}